import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { BackLogoIconButton } from '../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText';
import { TopTextReusableComponent } from '../../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent';
import { ReusableOnboardingButton, ReusableOnboardingLink } from '../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton';
import { ToggleButtonReuseTwo } from '../../../AllButton/ToggleButtonReuse';
import { ToggleButtonWithYesNo } from '../../../AllButton/ToggleButtonReuse';
import { Button, Image } from "react-bootstrap";
import Alert from "react-s-alert";
import Media from 'react-media';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { admin_update_new_subscription_for_vendor } from '../../../../../../store/actions/SuperAdminActions/adminNewVendorOnboard';
import { AmealioLoader } from '../../../../../Loader/AmealioLoader';
import LeftSideNavigation from '../../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation';
import HomeReusableTopBarNavigation from '../../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation';


export const AdminCasualDiningExperienceManagement = (props) => {
    console.log("Props of experience",props)
    const [disabled, setDisable] = useState(
        props &&
        props.history &&
        props.history.location &&
        props.history.location.state &&
        props.history.location.state.access === "view"
        ? true
        : false
    );
    const history = useHistory();
    const [state, setState]=useState({
        casualDiningOfflineExperience: false,
        casualDiningOnlineExperience: true,
    });

    const onClickCasualOnlineExperience = (e) => {
        if (state.casualDiningOnlineExperience === true) {
          setState({
            ...state,
            casualDiningOnlineExperience: !state.casualDiningOnlineExperience,
          });
        } else {
          history.push("/admin-casual-dining/experience/online");
        }
      };
    const onClickCasualOfflineExperience = (e) => {
        if (state.casualDiningOfflineExperience === true) {
          setState({
            ...state,
            casualDiningOfflineExperience: !state.casualDiningOfflineExperience,
          });
        } else {
          history.push("/admin-casual-dining/experience/offline");
        }
      };
    
    const onCasualOnlineExperienceSubmitClick = () => {
        let values = {
          value:
            state.casualDiningOfflineExperience === false &&
            state.casualDiningOnlineExperience === false
              ? false
              : true,
          offline_experience: {
            value: state.casualDiningOfflineExperience,
          },
          online_experience: {
            value: state.casualDiningOnlineExperience,
          },
        };
        const token = props.auth.user.accessToken;
        const subscriptionId = props.subscription._id;
        let formData = props.allSubscriptionsData;
    // formData.casual_dining_status.experience_management = values;
        formData.casual_dining_status.experience_management.value = values.value;
        formData.casual_dining_status.experience_management.offline_experience.value =
          values.offline_experience.value;
        formData.casual_dining_status.experience_management.online_experience.value =
          values.online_experience.value;
    console.log(subscriptionId, formData, token);
        props.admin_update_new_subscription_for_vendor(
          subscriptionId,
          formData,
          token,
          onSuccess
        );
      };
      const onSuccess = (e) => {
        Alert.success("<h4>Experience subscription add successfully</h4>", {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        history.push(
          props.editDataAction
            ? "/admin-edit-add-subscription"
            : "/admin-add-subscription"
        );
      };
      
      useEffect(() => {
        setState({
            ...state,
            casualDiningOfflineExperience:
            props.subscriptionData &&
            props.subscriptionData.offline_experience &&
            props.subscriptionData.offline_experience.value !== undefined
              ? props.subscriptionData &&
                props.subscriptionData.offline_experience &&
                props.subscriptionData.offline_experience.value
              : false,
          casualDiningOnlineExperience:
            props.subscriptionData &&
            props.subscriptionData.online_experience &&
            props.subscriptionData.online_experience.value !== undefined
              ? props.subscriptionData &&
                props.subscriptionData.online_experience &&
                props.subscriptionData.online_experience.value
              : false,

        });
      }, [props.subscriptionData]);

      if (props.auth.loader === true) {
        return(
            <React.Fragment>
                <AmealioLoader/>
            </React.Fragment>
        );
      } else {
        return (
            <React.Fragment>
            <div className="container-fluid">
              <div className="row">
                <div className="left-side-panel">
                  <LeftSideNavigation displayLink={1} />
                </div>
                <div className="super-admin-right-side-panel">
                  <HomeReusableTopBarNavigation />
                  <div
                    // id="onboarding-scrollbar"
                    className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 new-subscription-onboarding-component px-5 pt-4"
                  >
                    <div className="col-8 onboarding_process_screen-button-map inside-subscription-offers-section p-0">
                      <TopTextReusableComponent headingText="Experience Management" />
                      <div className="col-12 p-0">
                        <div className="f16-700 my-4">Activate Experience Types</div>
                        <ToggleButtonReuseTwo
                          mainText="Offline Experiences"
                          paragraphText="(Note: Experiences are in a physical venue and you can even accept RSVP)"
                          checkedBox={state.casualDiningOfflineExperience}
                          onChange={onClickCasualOfflineExperience}
                          disabled={disabled}
                        />
                        <hr className="mt-5 mb-5" />
                        <ToggleButtonReuseTwo
                          mainText="Online Experiences"
                          paragraphText="(Note: Experiences are online you need a link stored at the time of experience creation You can accept RSVP for the experiences)"
                          checkedBox={state.casualDiningOnlineExperience}
                          onChange={onClickCasualOnlineExperience}
                          disabled={disabled}
                        />
                      </div>
                      <hr className="mt-5 mb-5" />
                      <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                  <div className="col-4 col-md-7 col-lg-6 p-0">
                    <div className="f14-700">Curbside Delivery Service</div>
                  </div>
                  <div className="col-5 col-md-6 col-lg-3">
                    <ToggleButtonWithYesNo
                    //   activeClass={state.casualFineDiningCurbsideDelivery}
                    //   checkedBox={state.casualFineDiningCurbsideDelivery}
                    //   onChange={onClickCurbsideDeliveryService}
                    //   disabled={disabled}
                    />
                  </div>
                  <div className="col-lg-5 col-md-6 col-4 mobile-p-0">
            
                    {/* {state.casualFineDiningCurbsideDelivery && ( */}
                      <div className="d-flex ml-2">
                        <>
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            // onClick={() =>
                            //   onClickCurbsideDeliveryService({ access: true })
                            // }
                          >
                            <Image
                              src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                              alt="View"
                              title="View"
                              fluid
                            />
                          </Button>
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            // onClick={() =>
                            //   onClickCurbsideDeliveryService({ access: false })
                            // }
                          >
                            <Image
                              src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                              alt="Edit"
                              title="Edit"
                              fluid
                            />
                          </Button>
                        </>
                      </div>
                    {/* )} */}
        
                  </div>
                </div>
                      <hr className="mt-5 mb-5" />
                      <div className="onboarding-map-setup-screen-autodetect-button mt-5">
                        <ReusableOnboardingLink
                          buttonTitle="Back Button"
                          buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                          buttonText="Back"
                          link={
                            props.editDataAction
                              ? "/admin-edit-add-subscription"
                              : "/admin-add-subscription"
                          }
                        />
                        {!disabled && (
                          <ReusableOnboardingButton
                            buttonTitle="Next Button"
                            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                            buttonText="Done"
                            buttonType="button"
                            onClick={onCasualOnlineExperienceSubmitClick}
                            disabled={disabled}
                          />
                        )}
                      </div> 
                    </div> 
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
          )

      }
    
  
};

AdminCasualDiningExperienceManagement.prototype = {
    auth: PropTypes.object.isRequired,
    subscription: PropTypes.object.isRequired,
    subscriptionData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    subscription:
      state?.superAdminOnboarding &&
      state?.superAdminOnboarding?.onboard_subscription_details,
    subscriptionData:
      state?.superAdminOnboarding &&
      state?.superAdminOnboarding?.onboard_subscription_details &&
      state?.superAdminOnboarding?.onboard_subscription_details
        ?.casual_dining_status &&
      state?.superAdminOnboarding?.onboard_subscription_details
        ?.casual_dining_status?.event_management,
    allSubscriptionsData:
      state?.superAdminOnboarding &&
      state?.superAdminOnboarding?.onboard_subscription_details,
    editData: state?.adminAllVendorsInfo?.superAdminMerchantEditInfo,
    editDataAction:
      state?.adminAllVendorsInfo?.superAdminMerchantEditType?.editData,
});




export default connect(mapStateToProps, {
    admin_update_new_subscription_for_vendor,
  })(withRouter(AdminCasualDiningExperienceManagement));